import { OrganizationUserBulkPublicKeyResponse } from "../../../abstractions/organization-user/responses";

export class ProviderUserBulkPublicKeyResponse extends OrganizationUserBulkPublicKeyResponse {}
